import { reactive, ref, toRefs, watch } from "vue";
import { isEmpty } from "@/utils/commonUtils";
// 做一个会话级别的存储
import { saveQaStepInfoContent, getQaStepInfoContent } from "@/utils/localStorageUtils";

export const clearQaStepInfo = () => {
    // qastepinfo = JSON.parse(initdata);
    saveQaStepInfoContent('')
}

export const useQaFormEffect = () => {
    // const qastepinfo = {
    //     productInfo:[]
    // }
    let qastepinfo = getQaStepInfoContent();
    if (!qastepinfo) {
        qastepinfo = {
            // 车辆信息
            // 可能需要拆分成问卷信息
            carInfo:
                {},
            // {
            //     brand: '',
            //     carstyle: '',
            //     carNo: '',
            //     carCjNo: '',
            //     carOwnerName: '',
            //     phoneNumber: '',
            //     code: '',

            //     phoneAreaCode: '',// 区号
            // }
            // ],
            // 产品信息
            productInfo: [
                // {
                //     productId: '',// 产品ID
                //     productName: '',// 产品名称
                //     productNo: '',// 卷型号
                //     productExpire: '',// 产品质保
                //     productContent: '',// 质保内容
                //     questionnaireId:'',// 问卷 id
                //     warrantyConfigId:'',// 质保配置 id
                //     doCarPartComponentList: [],// 装贴部位的列表展示
                //     doCarPart: [],// 装贴部位
                //     问卷

                // }
            ],
            // 装贴信息
            doInfo: {
                doDate: '', // 装贴日期
                doCarPart: [],// 装贴部位
                doCarShop: '',// 装贴门店
                doCarShopId: '',// 装贴门店的ID
                doPrice: '', // 装贴价格

            },
            // 车主信息
            ownerinfo: {
                phoneNumber: '',// 手机号
                smsVerificationCode: '',//验证码
                fullName: '',// 名称
            },
            // 质保内容
            qaInfo: {
                content: '水斑、发污、水解、黄变',
            },
            // 装贴照片
            // imgInfo: {
            //     imageOne: {},
            //     imageTwo: {},
            //     imageThree: {},
            //     imageFour: {},
            //     imageFive: {},
            //     imageSix: {},
            // }
            // 装贴信息的话 要重新处理一下
            imgInfo: [

            ]
            // imgInfo:[
            // {    
            //    warrantyConfigId:
            //     component:[]
            //      config:[]
            // }
            // ]
        }
    }
    console.log('我每次进来的数据', qastepinfo)
    const qaObj = reactive(qastepinfo)
    const isCanClickCheckbox = ref(false)

    const saveQaStepInfo = () => {
        console.log("saveQaStepInfo", qastepinfo);
        saveQaStepInfoContent(qastepinfo);

    }

    const saveQaStepInfoCache = () => {
        console.log("saveQaStepInfo", qastepinfo);
        saveQaStepInfoContent(qastepinfo);

    }
    // const saveQaStepInfoCache = (newdata) => {
    //     console.log("newdata", newdata);
    //     saveQaStepInfoContent(newdata);

    // }
    const getNewData = () => {
        return getQaStepInfoContent();
    }

    // 删除qa的productinfo
    const deleteQaProductInfo = (index) => {
        // console.log('deleteQaProductInfo', qastepinfo)
        // qastepinfo.productInfo.splice(index, 1)
        qaObj.productInfo.splice(index, 1)
        saveQaStepInfo();
    }

    // setTimeout(() => {
    //     qastepinfo.qaInfo.content = '哈哈哈哈哈'
    //     console.log('setTimeout hahahah', qaObj)
    // }, 3000);

    return {
        qaObj,
        isCanClickCheckbox,
        saveQaStepInfo,
        saveQaStepInfoCache,
        deleteQaProductInfo,
        getNewData
    };
}

